<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('contact_email.add_email_long') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 overflow-x-hidden">
        <el-form :model="form" ref="ruleForm" :rules="rules">
          <div class="lg:mb-2">
            <div ref="Email">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contact_email.entity_name') }}</label>
              <el-form-item prop="Email">
                <el-input clearable class="w-full" v-model="form.Email" maxlength='50'/>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" />
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import BaseDialogButton from './base/BaseDialogButton.vue'
import { email as emailRegex } from '@/utils/regex'
import { addEmailContacto } from '@/services/configurations/addEmailContacto'

export default
{
  name: 'new-contact-email-dialog',
  components: {
    BaseDialogButton
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      // heightSelect: 0,
      // heightInput: 64,
      isOpen: this.dialogOpen,
      values: [],
      form: this.getDefaultForm(),
      rules: {
        Email: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
  },
  mounted: async function () {
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role'].toLowerCase()
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    idSede: function () {
      return parseInt(this.$route.params.idSede)
    },
  },
  methods: {
    getDefaultForm: function () {
      return {
        Email: ''
      }
    },
    isEmailValid: function (rule, value, callback) {
      if (!emailRegex.test(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else {
        callback()
      }
    },
    toggleDialog: function () {
      this.form = this.getDefaultForm()
      // if (this.dialogOpen) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function (ruleForm) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          const params = {
            idSociedad: this.id,
            idSede: this.idSede,
            email: this.form.Email
          }       
          const response = await addEmailContacto(params)
          if (response.blnError === true) {
            this.doFeedback(`${response.msgError} [${response.codError}]`)
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.form = this.getDefaultForm()
            this.isOpen = !this.isOpen
            this.$emit('toggleDialog')
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
  }
}
</script>
